module.exports = __webpack_public_path__ + "img/fwdUpOff.13ed0c35.svg";